"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionItem = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = __importDefault(require("../styles/theme"));
const Collapser_1 = require("../collapser/Collapser");
// 30px == --pad4, missing in theme
const StyledAccordionItem = styled_1.default.div `
	background: #fff;
	${({ noBorder }) => !noBorder && `border-bottom: 1px solid ${theme_1.default.colours.neutral.light};`};

	& > :first-of-type {
		/* First child needs no margin as there's padding from here */
		margin-top: 0;
	}
`;
// this may look like a simple pass-through
// but it has to be done this way to support the hackery going on in the main Accordion
const AccordionItem = (props) => {
    return React.createElement(StyledAccordionItem, { noBorder: props.noBorder },
        React.createElement(Collapser_1.Collapser, { collapsed: props.open === false }, props.children));
};
exports.AccordionItem = AccordionItem;
//# sourceMappingURL=AccordionItem.js.map